import BaseModel from './base_model';
import busStopPopup from '../templates/popups/bus_stop';

export default class BusStop extends BaseModel {
	/**
	 * Represents a Gtfs::Stop linked to the server API.
	 * @constructor
	 * @param {integer} stop_code - The stop_code of the Rails Gtfs::Stop.
	 */
	constructor(stop_code) {
		super();
		this.stop_code = stop_code;
		this.human_code = stop_code.replace(/^[0]+/, '');
		this.url = W.api_root + 'bus_stops' + '/' + this.stop_code + '.json';
		this.key = 'BusStop_' + this.stop_code;
		this.object_type = 'bus-stops';
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'bus_stops' + '/' + this.stop_code + '.html';
	}

	popupContent() {
		this.setHtmlView();

		// Bit hacky, but let's us avoid making an API call
		// when loading a route (which has all the other data we need)
		if ('undefined' === typeof this.data) {
			this.data = {};
			this.data.routes = this.routes;
		}
		return busStopPopup(this);
	}
}
